/* Every screen in every skin, side by side — live frames, scaled down, for comparing looks. */

const SCREENS = [
  { path: '/hub', name: 'Guild Hall' },
  { path: '/tracker', name: 'Ledger · Log' },
  { path: '/tracker?view=stats', name: 'Ledger · Stats' },
  { path: '/preview/marathon', name: 'Marathon rotation' },
];
const SKINS = [
  { id: 'arcade', name: "Wizard's Grimoire" },
  { id: 'inevitrade', name: 'Inevitrade' },
];

const FRAME_W = 1280;
const FRAME_H = 860;
const SCALE = 0.42;

export function SkinMosaic() {
  const withSkin = (path: string, skin: string) => `${path}${path.includes('?') ? '&' : '?'}skin=${skin}`;
  return (
    <div style={{ minHeight: '100vh', background: '#111', color: '#ddd', fontFamily: 'Inter, sans-serif', padding: 24 }}>
      <div style={{ display: 'grid', gridTemplateColumns: `140px repeat(${SKINS.length}, ${FRAME_W * SCALE}px)`, gap: 16, alignItems: 'start' }}>
        <div />
        {SKINS.map(s => <div key={s.id} style={{ fontWeight: 700, fontSize: 18 }}>{s.name}</div>)}
        {SCREENS.map(sc => [
          <div key={sc.path} style={{ fontSize: 13, color: '#999', paddingTop: 8 }}>{sc.name}</div>,
          ...SKINS.map(s => (
            <div key={sc.path + s.id} style={{ width: FRAME_W * SCALE, height: FRAME_H * SCALE, overflow: 'hidden', borderRadius: 6, boxShadow: '0 0 0 1px #333' }}>
              <iframe title={`${sc.name} — ${s.name}`} src={withSkin(sc.path, s.id)} width={FRAME_W} height={FRAME_H}
                style={{ border: 0, transform: `scale(${SCALE})`, transformOrigin: '0 0' }} />
            </div>
          )),
        ])}
      </div>
    </div>
  );
}
